module.exports = __webpack_public_path__ + "img/18_001.9976cd04.webp";